import {jQuery as $, lodash as _} from 'lib/shim';

import {waitForRepaint} from 'util/dom';


const NAME = 'molecule-video',
	SELECTOR = '.'+NAME;



class MoleculeVideo {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$poster = this._$element.find('.poster').first();
			this._$player = this._$element.find('.player').first();

			this._prime();
		}
	}



	_prime(){
		this._$poster.on('click', (e) => {
			let $template = this._$player.find('.embed-template');

			this._$poster.remove();
			this._$player.append($($template.html()));

			$template.remove();
		});

		this._$element.on('reset', () => {
			const html = this._$player.html();

			waitForRepaint(() => {
				this._$player.empty();

				waitForRepaint(() => {
					this._$player.html(html);
				});
			});
		});
	}

}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);
		new MoleculeVideo(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}
